export const PAY_STATUS = {
  REJECTED: 'rejected',
  PROCESSING: 'processing',
  CONFIRMED: 'confirmed',
}
